const codigoPiezaSeparada = 'PS'
const regexFileName = /^[a-zA-Z0-9ñÑçÇÁÉÍÓÚáéíóúÄËÏÖÜäëïöüÀÈÌÒÙâêîôû'_.$\s-]*$/
const regexNumber = /^[0-9]*$/
const regexNumberOrDot = /^\d+(\.\d+)*$/
const regexUnlimitedDecimals = /^\d+(\.\d+)*$/
const regexYear = /^(19|20)\d{2}$/
const regexExcludedCharacters = /^[^<>&]+$/

const regexDecimals = (number = 13): RegExp => {
  return new RegExp(`^\\d{1,${number}}(\\.\\d{1,2})?$`)
}

export {
  codigoPiezaSeparada,
  regexDecimals,
  regexFileName,
  regexNumber,
  regexNumberOrDot,
  regexUnlimitedDecimals,
  regexYear,
  regexExcludedCharacters
}
